import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Modal, Button, Form, Badge, Table } from "react-bootstrap";
import ToastMessage from "../components/ToastMessage";

function BuyPage() {
    const navigate = useNavigate();
    const apiBase = process.env.REACT_APP_SERVER_URL;
    const pricePerQty = 11;
    const winningAmountPerQty = 100;

    const user = JSON.parse(localStorage.getItem("user")) || {};

    const [allSeries, setAllSeries] = useState([]);
    const [seriesList, setSeriesList] = useState([]);
    const [results, setResults] = useState([]);
    const [form, setForm] = useState({ seriesId: "", first: {}, second: {} });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [modalShow, setModalShow] = useState(false);
    const [selectedNumber, setSelectedNumber] = useState({ position: "", number: "" });
    const [modalQuantity, setModalQuantity] = useState(1);
    const [purchases, setPurchases] = useState([]);
    const [purchaseLoading, setPurchaseLoading] = useState(false);
    const [purchaseError, setPurchaseError] = useState("");
    const [toast, setToast] = useState({ type: "", message: "" });
    const [userData, setUserData] = useState(user);
const [adminPhone, setAdminPhone] = useState("");


    const userPoints = userData?.points || 0;

    // slot object array: [{id: 1, slot: "09:00"}, ...]
    const [slots, setSlots] = useState([]);
    // This now stores the numerical ID of the selected slot, matching backend's slot
    const [selectedSlot, setSelectedSlot] = useState("");


    // --- API Calls (Wrapped in useCallback) ---
const fetchAdminInfo = useCallback(async () => {
    try {
        const res = await axios.get(`${apiBase}/api/auth/admin/info?email=admin@gmail.com`);
        
        
        if (res.data.success) {
            setAdminPhone("91" + res.data.data.phone);
        }
    } catch (err) {
        console.error("Failed to fetch admin info:", err);
    }
}, [apiBase]);
    const fetchUserData = useCallback(async () => {
        if (!user.id) return;
        try {
            const res = await axios.get(`${apiBase}/api/users/${user.id}`);
            setUserData(res.data);
            localStorage.setItem("user", JSON.stringify(res.data));
        } catch (err) {
            console.error("Failed to fetch user info:", err);
        }
    }, [apiBase, user.id]);

    const fetchAllSeries = useCallback(async () => {
        try {
            const res = await axios.get(`${apiBase}/api/admin/series`); 
            setAllSeries(res.data);
        } catch (err) {
            console.error(err);
        }
    }, [apiBase]);

    const fetchResults = useCallback(async () => {
        try {
            const res = await axios.get(`${apiBase}/api/results`);
            setResults(res.data);
        } catch (err) {
            console.error(err);
        }
    }, [apiBase]);

    const fetchUserPurchases = useCallback(async () => {
        if (!user.id) return;
        setPurchaseLoading(true);
        try {
            const res = await axios.get(`${apiBase}/api/buy/all/${user.id}`);
            // Assuming the purchases API returns slot time as 'slot_time'
            setPurchases(res.data);
        } catch (err) {
            setPurchaseError(err.response?.data?.msg || "Failed to fetch purchases");
        } finally {
            setPurchaseLoading(false);
        }
    }, [apiBase, user.id]);

    // 🔹 Initial load
    useEffect(() => {
        fetchAllSeries();
        fetchResults();
        fetchUserPurchases();
        fetchUserData();
        fetchAdminInfo();
    }, [fetchAllSeries, fetchResults, fetchUserPurchases, fetchUserData,fetchAdminInfo]);

    // 🔹 Update available series after results
    useEffect(() => {
        setSeriesList(allSeries);
        if (form?.seriesId && !allSeries.find(s => s.id === form?.seriesId)) {
            setForm({ seriesId: "", first: {}, second: {} });
        }
    }, [allSeries, results]);

    // 🔹 Handle series selection and fetch available slots
    const handleSeriesChange = async (e) => {
        const seriesId = e.target.value;
        setForm({ seriesId, first: {}, second: {} });
        setError("");

        if (!seriesId) {
            setSlots([]);
            setSelectedSlot("");
            return;
        }

        // --- Prepare Time and Date Parameters ---
        const now = new Date();
        const currentTime = `${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}`;
        // ----------------------------------------

        try {
            const res = await axios.get(`${apiBase}/api/slot-set/available-slots`, {
                params: {
                    seriesId,
                    currentTime: currentTime
                }
            });

            //console.log('Available slots data:', res.data);

            // Assuming res.data returns [{ id: number, slot: "time" }, ...]
            setSlots(res.data);

            // Set default slot ID
            if (res.data.length > 0) {
                setSelectedSlot(res.data[0].id);
            } else {
                setSelectedSlot("");
                setError("No future slots available for this series.");
            }
        } catch (err) {
            console.error("Failed to fetch slots:", err);
            setError(err.response?.data?.msg || "Failed to fetch slots.");
            setSlots([]);
            setSelectedSlot("");
        }
    };


    const handleNumberClick = (position, number) => {
        // Use selectedSlot for check
        if (!selectedSlot) {
            setError("Please select a Series and Slot first.");
            return;
        }
        setSelectedNumber({ position, number });
        setModalQuantity(form[position][number] || 1);
        setModalShow(true);
    };

    const handleModalSave = () => {
        const { position, number } = selectedNumber;
        const quantity = Number(modalQuantity);

        if (quantity <= 0 || !Number.isInteger(quantity)) {
            setForm(prev => {
                const newPosition = { ...prev[position] };
                delete newPosition[number];
                return { ...prev, [position]: newPosition };
            });
        } else {
            setForm(prev => ({
                ...prev,
                [position]: { ...prev[position], [number]: quantity }
            }));
        }

        setModalShow(false);
    };

    // 🔹 Buy handler
  const handleBuy = async (e) => {
    e.preventDefault();

    if (!form.seriesId) {
        setError("Please select a series.");
        return;
    }

    if (!selectedSlot) {
        setError("Please select a slot.");
        return;
    }

    const totalQty = [
        ...Object.values(form.first),
        ...Object.values(form.second)
    ].reduce((a, b) => a + b, 0);

    if (totalQty === 0) {
        setError("Please select at least one number.");
        return;
    }

    if (!user.id) {
        navigate("/login");
        return;
    }

    const selectedSeries = seriesList.find(
        (s) => s.id === Number(form.seriesId)
    );

    if (!selectedSeries) {
        setError("The selected series is unavailable.");
        fetchAllSeries();
        return;
    }

    const totalAmount = totalQty * pricePerQty;

    if (userPoints < totalAmount) {
        setError(
            `Insufficient points! You have ${userPoints} points but need ${totalAmount} points.`
        );
        return;
    }

    setError("");
    setLoading(true);

    try {
        const payload = {
            userId: user.id,
            seriesId: form.seriesId,
            slot: selectedSlot,
            first: form.first,
            second: form.second,
        };

        // Purchase
        await axios.post(`${apiBase}/api/buy`, payload);

        // Update points
        const newPoints = userPoints - totalAmount;

        await axios.put(
            `${apiBase}/api/users/points/${user.id}`,
            { points: newPoints }
        );

       

        // Refresh data
        await fetchUserData();
        await fetchUserPurchases();

        setToast({
            type: "success",
            message: `✅ Purchase successful! Total: ${totalAmount} points spent.`,
        });

        // Reset form
        setForm({
            seriesId: "",
            first: {},
            second: {},
        });

        setSlots([]);
        setSelectedSlot("");

    } catch (err) {
        console.error(err);

        setError(
            err.response?.data?.msg ||
            "Purchase failed. Please try again."
        );
    } finally {
        setLoading(false);
    }
};
    const totalQty = [...Object.values(form.first), ...Object.values(form.second)].reduce((a, b) => a + b, 0);
    const totalAmount = totalQty * pricePerQty;
    const potentialWinning = totalQty * winningAmountPerQty;

    return (
        <div className="container mt-5">
            <div className="d-flex justify-content-start mb-3">
                <button className="btn btn-secondary" onClick={() => navigate(-1)}>
                    &larr; Back
                </button>
            </div>

            <div className="row">
                {/* Left Panel - Buy Lottery */}
                <div className="col-lg-6 mb-4">
                    <div className="card shadow-sm p-4 h-100">
                        <h3 className="text-center mb-4">Buy Lottery</h3>
                        <p><strong>Available Points:</strong> <Badge bg="success">{userPoints}</Badge></p>
                        {error && <div className="alert alert-danger">{error}</div>}

                        <form onSubmit={handleBuy}>
                            <div className="mb-3">
                                <label className="form-label">Series</label>
                                <select
                                    className="form-select"
                                    value={form.seriesId}
                                    onChange={handleSeriesChange}
                                    required
                                >
                                    <option value="">Select series</option>
                                    {seriesList.length === 0 && <option disabled>No series available</option>}
                                    {seriesList.map(s => (
                                        <option key={s.id} value={s.id}>{s.name}</option>
                                    ))}
                                </select>
                            </div>
                            {slots.length > 0 && (
                                <div className="mb-3">
                                    <label className="form-label">Slot Time</label>
                                    <select
                                        className="form-select"
                                        // Use selectedSlot here
                                        value={selectedSlot}
                                        onChange={(e) => setSelectedSlot(e.target.value)}
                                        required
                                    >
                                        <option value="">Select slot</option>
                                        {/* Use slot.id as the value to send back to the server */}
                                        {slots.map(slot => (
                                            <option key={slot.id} value={slot.slot}>
                                                {slot.slot}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            )}
                            {form.seriesId && slots.length === 0 && <div className="alert alert-warning">No future slots available for this series.</div>}

                            <div className="mb-3">
                                <label className="form-label">Select Numbers</label>
                                <div className="d-flex flex-column gap-2">
                                    {["I", "II"].map((roman, idx) => (
                                        <div key={roman} className="d-flex align-items-center gap-2 flex-wrap">
                                            <span className="fw-bold me-2">{roman}</span>
                                            {[...Array(10).keys()].map(n => {
                                                const position = idx === 0 ? "first" : "second";
                                                const qty = form[position][n];
                                                return (
                                                    <button
                                                        key={n}
                                                        type="button"
                                                        // Disable button if no slot ID is selected
                                                        disabled={!selectedSlot}
                                                        className={`btn btn-sm ${qty ? "btn-primary" : "btn-outline-secondary"} mb-1`}
                                                        onClick={() => handleNumberClick(position, n)}
                                                        title={`Quantity: ${qty || 0}`}
                                                    >
                                                        {n}{qty ? ` (${qty})` : ""}
                                                    </button>
                                                );
                                            })}
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <div className="d-flex justify-content-between mb-3 flex-wrap">
                                <Badge bg="info" className="mb-1">Total Qty: {totalQty}</Badge>
                                <Badge bg="warning" text="dark" className="mb-1">Total Cost: {totalAmount} pts</Badge>
                                <Badge bg="success" className="mb-1">Potential Winning: ₹{potentialWinning}</Badge>
                            </div>

                            <button
                                type="submit"
                                className="btn btn-primary w-100"
                                disabled={loading || !selectedSlot || totalAmount === 0 || totalAmount > userPoints}
                            >
                                {totalAmount > userPoints ? "Insufficient Points" : loading ? "Processing..." : "Buy Now"}
                            </button>
                        </form>
                    </div>
                </div>

                {/* Right Panel - Purchases */}
                <div className="col-lg-6 mb-4">
    <div className="card shadow-sm p-4 h-100" style={{ maxHeight: '500px', display: 'flex', flexDirection: 'column' }}>
        <h4 className="mb-3">Your Purchases</h4>

        {purchaseLoading && <p className="text-center">Loading purchases...</p>}
        {purchaseError && <div className="alert alert-danger">{purchaseError}</div>}
        {!purchaseLoading && purchases.length === 0 && <p className="text-center">No purchases made today.</p>}

        {purchases.length > 0 && (
            /* added overflow and flex-grow to make this part scrollable */
            <div className="table-responsive" style={{ overflowY: 'auto', flexGrow: 1 }}>
                <Table striped bordered hover size="sm" className="align-middle mb-0">
                    <thead className="table-light" style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                        <tr>
                            <th>Series</th>
                            <th>Slot</th>
                            <th>Numbers</th>
                            <th>Total Qty</th>
                            <th>Total Cost</th>
                            <th>Purchased At</th>
                        </tr>
                    </thead>

                    <tbody>
                        {purchases.map((p, idx) => (
                            <tr key={idx}>
                                <td>{p.series}</td>
                                <td>{p.slot}</td>
                                <td>{p.numbers}</td>
                                <td>{p.total_qty}</td>
                                <td>₹{p.total_cost}</td>
                                <td style={{ fontSize: "0.85em" }}>
                                    {new Date(p.created_at).toLocaleString([], { 
                                        dateStyle: 'short', 
                                        timeStyle: 'short' 
                                    })}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
        )}
    </div>
</div>
            </div>

            {/* Quantity Modal */}
            <Modal show={modalShow} onHide={() => setModalShow(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Enter Quantity for {selectedNumber.number}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group>
                        <Form.Label>Quantity</Form.Label>
                        <Form.Control
                            type="number"
                            min="0"
                            value={modalQuantity}
                            onChange={(e) => setModalQuantity(e.target.value)}
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setModalShow(false)}>Cancel</Button>
                    <Button variant="primary" onClick={handleModalSave}>
                        {Number(modalQuantity) > 0 ? `Save ${modalQuantity}` : "Clear Selection"}
                    </Button>
                </Modal.Footer>
            </Modal>

            {toast.message && <ToastMessage type={toast.type} message={toast.message} />}
        </div>
    );
}

export default BuyPage;